import React from 'react';
import Multioption from './Multioption';
import { isMultioptionFieldType, parseStoredFieldValue, toggleMultioptionValue } from '../../utils/fieldValueCoercion';

interface FieldGroupMultioptionProps {
    field: { name: string; type?: string; options?: { label: string; value: string }[] };
    value: unknown;
    mode: 'show' | 'input';
    onChange?: (value: { multioption: string }[]) => void;
}

/** Shared multioption renderer for field-group show + edit (same chips, mode differs). */
const FieldGroupMultioption: React.FC<FieldGroupMultioptionProps> = ({ field, value, mode, onChange }) => {
    const parsed = parseStoredFieldValue(value, field.type);
    const safeValue = Array.isArray(parsed) ? parsed : [];

    return (
        <Multioption
            mode={mode}
            label={field.name}
            name={field.name}
            options={field.options || []}
            value={safeValue}
            multiOptionSelected={
                mode === 'input' && onChange
                    ? (optionValue) => onChange(toggleMultioptionValue(safeValue, optionValue))
                    : undefined
            }
        />
    );
};

export default FieldGroupMultioption;
